import { MutationTree } from 'vuex';
import { IEntityState } from '../stores/entity.store';
import { IUser } from '@/types/User';
import { IEntity } from '@/types/Entity';
import { ITeam } from '@/types/Team';
import { IPlanStatus } from '@/types/plan-status';

export const mutationLoadingEntity = 'loadingEntity';
export const mutationSetEntitySettings = 'setEntitySettings';
export const mutationUpdateEntitySettings = 'updateEntitySettings';
export const mutationSetUsers = 'setUsers';
export const mutationSetTeams = 'setTeams';
export const mutationSetIsLoadingTeams = 'setIsLoadingTeams';
export const mutationSetPlanStatus = 'setPlanStatus';

export const mutationSetEntity = 'setEntity';

export const mutations: MutationTree<IEntityState> = {
  [mutationLoadingEntity](state: IEntityState, payload: boolean) {
    state.isLoading = payload;
  },
  [mutationSetEntitySettings](state: IEntityState, payload: IEntity) {
    state.entityId = payload.entityId;
  },
  [mutationSetUsers](state: IEntityState, payload: IUser[]) {
    state.users = payload;
  },
  [mutationSetTeams](state: IEntityState, payload: ITeam[]) {
    state.teams = payload;
  },
  [mutationSetIsLoadingTeams](state: IEntityState, payload: boolean) {
    state.isLoadingTeams = payload;
  },
  [mutationSetEntity](state: IEntityState, payload: IEntity) {
    state.entity = payload;
  },
  [mutationSetPlanStatus](state: IEntityState, payload: IPlanStatus) {
    state.planStatus = payload;
  },
};
